module.exports = __webpack_public_path__ + "img/test.b8f94f3b.png";